import { z } from 'zod/mini'

const TypeFilterItem = z.object({
  code: z.string(),
  label: z.string(),
  recordCount: z.optional(z.number()),
  isInProgress: z.optional(z.boolean()),
  isDeleted: z.optional(z.boolean()),
  icon: z.any(),
  memo: z.optional(z.string())
})

const _TypeFilterProps = z.object({
  title: z.string(),
  types: z.array(TypeFilterItem),
  recordCountGetter: z.function({
    input: [z.string()],
    output: z.number()
  }),
  onSelectItem: z.function({
    input: [TypeFilterItem]
  }),
  selectedItemCode: z.string(),
  onFilter: z.function({
    input: [z.string()]
  }),
  registerButton: z.any(),
  onShowMemoModal: z.optional(
    z.function({
      input: [TypeFilterItem]
    })
  ),
  statusGetter: z.optional(
    z.function({
      input: [z.string()],
      output: z.nullable(z.string())
    })
  ),
  /** 区分コード単位でエラー表示（例: 左一覧の赤背景） */
  itemErrorGetter: z.optional(
    z.function({
      input: [z.string()],
      output: z.boolean()
    })
  )
})

export const TypeFilterProps = z.partial(_TypeFilterProps)
